import type { Position, PointItem } from '../types';

export const findNearestSegment = (position: Position, points: PointItem[]): number => {
  let minDistance = Infinity;
  let insertIndex = 1;

  for (let i = 0; i < points.length - 1; i++) {
    const start = points[i].position;
    const end = points[i + 1].position;
    if (!start || !end) continue;

    // Berechne den Abstand des Punktes zum Liniensegment
    const distance = calculateDistanceToSegment(position, start, end);
    
    if (distance < minDistance) {
      minDistance = distance;
      insertIndex = i + 1;
    }
  }

  return insertIndex;
};

const calculateDistanceToSegment = (point: Position, start: Position, end: Position): number => {
  const x = point.lng;
  const y = point.lat;
  const x1 = start.lng;
  const y1 = start.lat;
  const x2 = end.lng;
  const y2 = end.lat;

  const A = x - x1;
  const B = y - y1;
  const C = x2 - x1;
  const D = y2 - y1;

  const dot = A * C + B * D;
  const len_sq = C * C + D * D;
  let param = -1;

  if (len_sq !== 0) {
    param = dot / len_sq;
  }

  let xx, yy;

  if (param < 0) {
    xx = x1;
    yy = y1;
  } else if (param > 1) {
    xx = x2;
    yy = y2;
  } else {
    xx = x1 + param * C;
    yy = y1 + param * D;
  }

  const dx = x - xx;
  const dy = y - yy;

  return Math.sqrt(dx * dx + dy * dy) * 111000; // Umrechnung in Meter (ca.)
};